<template>
  <div>
    <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_1" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-1.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_5" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-5.png?alt=media">
    </div>
    <div class="column">
        <img alt="hvc_gallery_4" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-4.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_3" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-3.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_2" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-2.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_12" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-12.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_11" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-11.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_8" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-8.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_9" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-9.png?alt=media">
    </div>
    </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_10" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-10.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_7" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-7.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_6" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-6.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_13" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-13.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_14" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-14.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_15" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-15.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_16" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-16.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_17" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-17.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_18" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-18.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_28" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-28.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_20" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-20.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_21" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-21.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_36" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-36.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_35" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-35.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_34" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-34.png?alt=media">
    </div>
  </div>
  <div class="columns">
    <div class="column is-4">
      <img alt="hvc_gallery_31" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-31.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_32" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-32.png?alt=media">
    </div>
    <div class="column">
      <img alt="hvc_gallery_33" src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/gallery-33.png?alt=media">
    </div>
  </div>

  </div>
</template>

<script>
export default {
  name: 'gallery'
}
</script>

<style>

</style>
